"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.MANUAL_PAY_OVERVIEW_SLC = exports.MANUAL_PAY_OVERVIEW_CB_RP_OFF = exports.MANUAL_PAY_OVERVIEW_CB_RP_ON = exports.MANUAL_PAY_OVERVIEW = void 0;
exports.MANUAL_PAY_OVERVIEW = {
    HEADER: 'Split your rent',
    BODY: 'Ready to use Flex to pay your rent?',
    LIST_HEADER: 'Here’s how it works...',
    LIST: {
        LIST_ONE: 'Confirm the amount you want Flex to pay to your property',
        LIST_TWO: 'Review your schedule of payments to Flex',
        LIST_THREE: 'Make your {{payment}} to Flex, and submit the full rent payment to your property'
    },
    CTA: 'Get started'
};
exports.MANUAL_PAY_OVERVIEW_CB_RP_ON = __assign(__assign({}, exports.MANUAL_PAY_OVERVIEW), { HEADER: 'Pay rent and boost your credit', BODY: 'Once you submit your rent payment in the app, Flex will get started sending credit-boosting reports!', LIST_HEADER: 'Here’s how it works...', LIST: {
        LIST_ONE: 'Confirm the rent amount you want to pay to your property',
        LIST_TWO: 'Make your rent payment, and we’ll transfer it to your property',
        LIST_THREE: 'We’ll report an on-time rent payment and responsible use of your credit line to the credit bureaus'
    } });
exports.MANUAL_PAY_OVERVIEW_CB_RP_OFF = __assign(__assign({}, exports.MANUAL_PAY_OVERVIEW_CB_RP_ON), { LIST: __assign(__assign({}, exports.MANUAL_PAY_OVERVIEW_CB_RP_ON.LIST), { LIST_TWO: 'Review your payment schedule', LIST_THREE: 'Pay your deposit and initiate the rent payment', LIST_FOUR: 'We’ll report an on-time rent payment and responsible use of your credit line to the credit bureaus' }) });
exports.MANUAL_PAY_OVERVIEW_SLC = __assign(__assign({}, exports.MANUAL_PAY_OVERVIEW), { LIST: {
        LIST_ONE: 'Confirm your monthly rent amount',
        LIST_TWO: 'Make your initial deposit to Flex',
        LIST_THREE: 'Flex pays your rent in full',
        LIST_FOUR: 'You then pay Flex back the remainder of your rent, plus a monthly rate.'
    } });
